import type { ReactNode } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import LogoFull from '../Root/LogoFull';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  paper: {
    padding: theme.spacing(4),
    maxWidth: 420,
    width: '100%',
  },
  logo: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(4),
    '& svg': {
      height: 32,
    },
  },
}));

/** The centred card with the logo that the sign-in screens share. */
export function SignInCard({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Paper
        className={className ? `${classes.paper} ${className}` : classes.paper}
        elevation={2}
      >
        <div className={classes.logo}>
          <LogoFull />
        </div>
        {children}
      </Paper>
    </div>
  );
}
